import React, { useEffect, useState } from "react";
import { Select, Space, Spin } from "antd";
import { usePermissions } from "../../../PermissionsProvider";
import { ApplicationService } from "../../../services/ApplicationService";
import { Application } from "../../../model_gen/application";
import StepHeader from "../StepHeader";

interface SelectApplicationProps {
  value?: Application;
  onChange: (application: Application) => void;
}

const SelectApplication: React.FC<SelectApplicationProps> = ({
  value,
  onChange,
}) => {
  const { apiKey } = usePermissions();
  const [applications, setApplications] = useState<Application[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ApplicationService.getApplications(null, apiKey).subscribe(
      (apps: Application[]) => {
        setApplications(apps);
        setLoading(false);
      },
      (error: any) => {
        console.error("Error fetching applications:", error);
        setLoading(false);
      }
    );
  }, [apiKey]);

  if (loading) {
    return (
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <StepHeader
          title="Select Application"
          description="Choose the application to evaluate"
        />
        <Spin />
      </Space>
    );
  }

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <StepHeader
        title="Select Application"
        description="Choose the application to evaluate"
      />
      
      <Select
        style={{ width: "100%", maxWidth: "500px" }}
        value={value?.id}
        onChange={(applicationId: number) => {
          const selectedApp = applications.find(app => app.id === applicationId);
          if (selectedApp) {
            onChange(selectedApp);
          }
        }}
        placeholder="Select an application"
        showSearch
        optionFilterProp="children"
        size="large"
      >
        {applications.map((app) => (
          <Select.Option key={app.id} value={app.id}>
            {app.application_name}
          </Select.Option>
        ))}
      </Select>
    </Space>
  );
};

export default SelectApplication;
